import React, { createContext, useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Grid } from "@mui/material";
import { Convert, ConvertDateToUnixOrNull, DefaultArrayEmpty, FnAxios, FnDialog, I18n, getMonthDifference } from "utilities/utilities";
import { BtnAdd, BtnCancel, BtnDelete, BtnSave } from "components/Button/ButtonAll";
import moment from "moment";
import { TextBoxItem } from "components/Input/TextBox";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { TextAreaItem } from "components/Input/TextArea";
import { SelectItem } from "components/Input/Select/SelectItem";
import UploadFileItem from "components/Input/UploadFile";
import ContentWrapper from "../components/ContentWrapper";
import { I18NextNs } from "enum/enum";
import { BtnDeleteOnTable, BtnEditOnTable, BtnViewDataOnTable } from 'components/Button/ButtonTable';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { List as LINQ } from "linqts";
import ChangeOrderCustom from "components/System/ChangeOrderCustom";

export default function PresentFrom(props) {
    const {
        sMode,
        sNameFrom,
        isEdit,
        isPresent,
        ObjProjectPresent,
        dProjectStart,
        lstPresent,
        setlstPresent,
        sEmailFile,
    } = props;

    const DialogFn = FnDialog();    
    const onClearFile = useRef(null);
    
    //#region sMode === "404"
    const [arrFilePresent, setarrFilePresent] = useState([]);
    
    const [nPresentIDEdit, setnPresentIDEdit] = useState(0);
    const [ObjPresentIDEdit, setObjPresentIDEdit] = useState(null);
    const [arrProjectPresent, setarrProjectPresent] = useState([]);
    const [DataRowPresent, setDataRowPresent] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "dUpdate",
        sSortDirection: "desc",
    });

    const formPresent = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });
    
    const handleChangeOrder = (nNewOrder, nOldOrder) => {
        let arrPresent = DataRowPresent;
        let arrRowPresent = arrPresent.arrRows;
        let objSelf = arrRowPresent.find((f) => f.nOrder === nOldOrder);
        //Order ใหม่มากกว่าเก่า
        if (nNewOrder > nOldOrder) {
            //เคสที่มากกว่าตัวเอง
            let arrChange = arrRowPresent.filter(
                (f) => f.nOrder > nOldOrder && f.nOrder <= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder--;
            });
        } else {
            //Order ใหม่น้อยกว่าเก่า
            //เคสที่น้อยกว่าตัวเอง
            let arrChange = arrRowPresent.filter(
                (f) => f.nOrder < nOldOrder && f.nOrder >= nNewOrder
            );
            arrChange.forEach((f) => {
                f.nOrder++;
            });
        }
        //อัพเดทตัวเอง
        objSelf.nOrder = nNewOrder;
        //เรียงลำดับ
        arrRowPresent = arrRowPresent.slice().sort((a, b) => a.nOrder - b.nOrder);

        arrPresent.arrRows = [...arrRowPresent];
        setDataRowPresent({ ...arrPresent });
        setarrProjectPresent([...arrRowPresent]);
        setlstPresent([...arrRowPresent]);
    };

    const dataColumn: any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 80,
            getActions: (item) => {
                return [          
                    isPresent ?
                        <>
                            <BtnDeleteOnTable
                                key={"btnDelete_Present_" + item.row.sID}
                                id={"btnDelete_Present_" + item.row.sID}
                                onClick={() => onDeletePresent(item.row.nID)}
                                IsDisabled={!isPresent}
                            />
                        
                            <BtnEditOnTable
                                key={"btnEdit_Present_" + item.row.sID}
                                id="btnEdit"
                                onClick={() => onEditPresent(item.row)}
                                IsDisabled={!isPresent}
                            />
                        </>
                    :
                        <BtnViewDataOnTable
                            key={"btnView_Present_" + item.row.sID}
                            id="btnView"
                            onClick={() => onEditPresent(item.row)}
                            // IsDisabled={!isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "nOrder",
            headerName: "ลำดับ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 100,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {
                let lstnOrder = new LINQ<any>(arrProjectPresent || []).Where(w=> w.nOrder !== 0).OrderBy(o=> o.value).Select(function(elem) {return { label: elem.nOrder, value: elem.nOrder, }}).ToArray();
                return (
                    <Grid item xs={12} md={12} key={"nOrder_TS4_" + item.row.sID}>
                        <ChangeOrderCustom
                            id={"nOrder_S4_" + item.row.sID}
                            item={item.row}
                            value={item.row.nOrder}
                            onChangeOrder={(sID, nOrder) =>
                                handleChangeOrder(+nOrder, +item.row.nOrder)
                            }
                            optOrder={lstnOrder ?? []}
                            IsView={false}
                            disabled={!isPresent}
                        />
                    </Grid>
                );
            },
        },
        {
            field: "sEventName",
            headerName: "ชื่องาน",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 3,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },      
        {
            field: "sPresentBy",
            headerName: "ชื่อผู้นำเสนอหลัก",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "nDatePresentStart",
            headerName: "วันที่นำเสนอ",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {
                let sDate = Convert.DateTimeToString(item.row.nDatePresentStart, "DD MMMM YYYY", "th");
                return (sDate);
            },
        },           
    ];

    const dataColumnPresent: any = [
        {
            field: "isEdit",
            headerAlign: "center",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 80,
            getActions: (item) => {
                return [          
                    isPresent ?
                        <>
                            <BtnDeleteOnTable
                                key={"btnDelete_Present_" + item.row.sID}
                                id={"btnDelete_Present_" + item.row.sID}
                                onClick={() => onDeletePresent(item.row.nID)}
                                IsDisabled={!isPresent}
                            />
                        
                            <BtnEditOnTable
                                key={"btnEdit_Present_" + item.row.sID}
                                id="btnEdit"
                                onClick={() => onEditPresent(item.row)}
                                IsDisabled={!isPresent}
                            />
                        </>
                    :
                        <BtnViewDataOnTable
                            key={"btnView_Present_" + item.row.sID}
                            id="btnView"
                            onClick={() => onEditPresent(item.row)}
                            // IsDisabled={!isPermission || isEditSecretary === false}
                        />
                ];
            },
        },
        {
            field: "nOrder",
            headerName: "ลำดับ",
            headerAlign: "center",
            align: "center",
            sortable: false,
            width: 100,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {
                let lstnOrder = new LINQ<any>(arrProjectPresent || []).Where(w=> w.nOrder !== 0).OrderBy(o=> o.value).Select(function(elem) {return { label: elem.nOrder, value: elem.nOrder, }}).ToArray();
                return (
                    <Grid item xs={12} md={12} key={"nOrder_TS4_" + item.row.sID}>
                        <ChangeOrderCustom
                            id={"nOrder_S4_" + item.row.sID}
                            item={item.row}
                            value={item.row.nOrder}
                            onChangeOrder={(sID, nOrder) =>
                                handleChangeOrder(+nOrder, +item.row.nOrder)
                            }
                            optOrder={lstnOrder ?? []}
                            IsView={false}
                            disabled={!isPresent}
                        />
                    </Grid>
                );
            },
        },
        {
            field: "sEventName",
            headerName: "ชื่องาน",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 3,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },      
        {
            field: "sJournalName",
            headerName: "ชื่อวารสาร",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },
        {
            field: "sPresentBy",
            headerName: "ชื่อผู้ตีพิมพ์ผลงานหลัก",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
        },  
        {
            field: "nDatePresentStart",
            headerName: "วันที่ตีพิมพ์",
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 2,
            disableColumnMenu: true, //ปิดตัวเปิดเมนูตรงหัวตาราง
            renderCell: (item) => {
                let sDate = Convert.DateTimeToString(item.row.nDatePresentStart, "DD MMMM YYYY", "th");
                return (sDate);
            },
        },           
    ];
    
    const onAddPresent = () => {
        if ((arrFilePresent || []).filter((f) => !f.isDelete).length === 0) {
            return DialogFn.Warning("กรุณาอัพโหลดไฟล์แนบเอกสาร");
        }        
        let sEventName = formPresent.getValues(`sEventName_S4_${sNameFrom}`);
        let ObjDuplicate = arrProjectPresent.filter((f) => !f.isDelete && (nPresentIDEdit !== 0 ? f.nID !== nPresentIDEdit : true) && f.sEventName === sEventName);
        if ((ObjDuplicate || []).length === 0)
        {   
            let nProjectPresentID = 0;
            let dataRow = DataRowPresent;
            let arrPresent = DefaultArrayEmpty(arrProjectPresent);
            let nMaxID = new LINQ<any>(arrPresent).Any() ? new LINQ<any>(arrPresent).Max((m) => m.nID) + 1 : 1;
            let nOrder = new LINQ<any>(arrPresent).Any() ? new LINQ<any>(arrPresent).Max((m) => m.nOrder) + 1 : 1;
            if (nPresentIDEdit) {
                arrPresent = arrPresent.filter((f) => f.nID !== nPresentIDEdit);
                nMaxID = nPresentIDEdit;
                let ObjPresent = arrProjectPresent.find((f) => f.nID === nPresentIDEdit);
                nProjectPresentID = ObjPresent?.nProjectPresentID;
                nOrder = ObjPresent?.nOrder;
            }

            let dPresentStart = moment(formPresent.getValues(`dPresentStart_S4_${sNameFrom}`));
            let dPresentEnd = ObjProjectPresent?.isNotDatePresentEnd === true ? null : moment(formPresent.getValues(`dPresentEnd_S4_${sNameFrom}`));
            let nDatePresentStart = dPresentStart.isValid ? ConvertDateToUnixOrNull(dPresentStart.startOf('month')) : null;
            let nDatePresentEnd = ObjProjectPresent?.isNotDatePresentEnd === true ? null : (dPresentEnd.isValid ? ConvertDateToUnixOrNull(dPresentEnd.endOf('month')) : null);

            let sDetail = formPresent.getValues(`sDetail_S4_${sNameFrom}`);
            let sJournalName = formPresent.getValues(`sJournalName_S4_${sNameFrom}`);
            let sArticleTitle = formPresent.getValues(`sArticleTitle_S4_${sNameFrom}`);
            let sPresentBy = formPresent.getValues(`sPresentBy_S4_${sNameFrom}`);

            let obj = {
                sID: nMaxID.toString(),
                nID: nMaxID,
                nOrder: nOrder,

                nProjectID: ObjProjectPresent?.nProjectID,
                sProjectName: "",  
                nPresentFormID: ObjProjectPresent?.nPresentFormID,
                isInternational: ObjProjectPresent?.isInternational,
                nProjectPresentID: nProjectPresentID,

                isPresent: ObjProjectPresent?.isPresent,
                nPresentTypeID: ObjProjectPresent?.nPresentTypeID,

                sEventName: sEventName,
                dPresentStart: dPresentStart,
                nDatePresentStart: nDatePresentStart,
                isNotDatePresentEnd: ObjProjectPresent?.isNotDatePresentEnd, //เอาแค่วันที่ ตีพิมพ์ เริ่มต้น
                dPresentEnd: dPresentEnd,
                nDatePresentEnd: nDatePresentEnd,
                sDetail: sDetail,
                sJournalName: sJournalName,
                sArticleTitle: sArticleTitle,
                sPresentBy: sPresentBy,
                nStatusID: ObjProjectPresent?.nStatusID,
                lstFilePresent: arrFilePresent,
            };

            let result = [...arrPresent, obj];
            let arrTable = new LINQ<any>(result || []).Where(w=> !w.isDelete).OrderBy(o=> o.nOrder).ToArray();
            setDataRowPresent({
                ...dataRow,
                nDataLength: arrTable.length,
                arrRows: arrTable,
            });
            setnPresentIDEdit(0);
            setObjPresentIDEdit(null);
            setarrProjectPresent(arrTable);
            setlstPresent(arrTable);
            onClearField();
        } 
        else {
            DialogFn.Warning(I18n.SetText("Title.Duplicate", I18NextNs.labelComponent));
        }
    };

    const onClearField = () => {
        Object.keys(formPresent.getValues()).forEach((key) => {
            formPresent.setValue(key, null);
            formPresent.clearErrors(key);
        });
        setarrFilePresent([]);
        onClearFile.current();
    };

    const onEditPresent = (ObjData) => {
        setnPresentIDEdit(ObjData.nID);   
        let ObjPresent = {
            sID: ObjData.sID,
            nID: ObjData.nID,
            isPresent: ObjData.isPresent,
            sProjectName: ObjData.sProjectName,

            nProjectPresentID: ObjData.nProjectPresentID,
            nOrder: ObjData.nOrder,
           
            nPresentFormID: ObjData.nPresentFormID,
            nProjectID: ObjData.nProjectID,
            nPresentTypeID: ObjData.nPresentTypeID,
            isInternational: ObjData.isInternational,

            sEventName: ObjData.sEventName,
            dPresentStart: ObjData.dPresentStart,
            nDatePresentStart: ObjData.nDatePresentStart,
            isNotDatePresentEnd: ObjData.isNotDatePresentEnd, //เอาแค่วันที่ ตีพิมพ์ เริ่มต้น
            dPresentEnd: ObjData.dPresentEnd,
            nDatePresentEnd: ObjData.nDatePresentEnd,
            sDetail: ObjData.sDetail,
            sJournalName: ObjData.sJournalName,
            sArticleTitle: ObjData.sArticleTitle,
            sPresentBy: ObjData.sPresentBy,
            nStatusID: ObjData.nStatusID,
            lstFilePresent: ObjData.lstFilePresent,
        };
        setObjPresentIDEdit(ObjPresent);
        formPresent.setValue(("sEventName_S4_" + sNameFrom), ObjPresent.sEventName);
        formPresent.setValue(("dPresentStart_S4_" + sNameFrom), moment(ObjPresent.nDatePresentStart));
        formPresent.setValue(("dPresentEnd_S4_" + sNameFrom), ObjPresent.isNotDatePresentEnd === true ? null : moment(ObjPresent.nDatePresentEnd));
        formPresent.setValue(("sDetail_S4_" + sNameFrom), ObjPresent.sDetail);
        formPresent.setValue(("sJournalName_S4_" + sNameFrom), ObjPresent.sJournalName);
        formPresent.setValue(("sArticleTitle_S4_" + sNameFrom), ObjPresent.sArticleTitle);
        formPresent.setValue(("sPresentBy_S4_" + sNameFrom), ObjPresent.sPresentBy);
        setarrFilePresent(ObjPresent.lstFilePresent ?? []);

        document.getElementById("myDivPresent").scrollIntoView({ behavior: "smooth" });
    }

    const onDeletePresent = (nID) => {
        DialogFn.Submit(I18n.SetText("Message.ConfirmDelete", I18NextNs.labelComponent), async () => {
            DialogFn.BlockUI();
            let arrPresentData: any[] = arrProjectPresent;
            let result = arrPresentData.filter((f) => f.nID !== nID);        
            let nNo = 1;
            result.forEach((f) => { f.nNo = nNo++; });
            DialogFn.UnBlockUI();
            DialogFn.Success(I18n.SetText("Message.DeleteComplete", I18NextNs.labelComponent), () => {});
            setDataRowPresent({
                ...DataRowPresent,
                nDataLength: result.length,
                arrRows: [...result],
            });
            setarrProjectPresent([...result]);
            setlstPresent([...result]);
        });
    };

    // useEffect(() => {
    //     if (sMode === "404" && ObjProjectPresent !== null && setlstPresent) setlstPresent(arrProjectPresent);
    // }, [arrProjectPresent]);

    useEffect(() => {
        if (sMode === "404" && ObjProjectPresent !== null && (ObjProjectPresent?.lstPresent || []).length > 0 && arrProjectPresent.length === 0) {
            setarrProjectPresent(ObjProjectPresent?.lstPresent ?? []);
            setDataRowPresent({
                ...initRows,
                nDataLength: (ObjProjectPresent?.lstPresent || []).length,
                arrRows: (ObjProjectPresent?.lstPresent || []),
            });
        }
    }, [sMode, ObjProjectPresent]);
    
    useEffect(() => {
        if (isPresent === false && isEdit === true) onClearField();
    }, [isPresent, isEdit]);
    //#endregion

    //#region sMode === "403"
    // useEffect(() => {
    //     if (sMode === "403" && ObjProjectPresent !== null) console.log("ObjProjectPresent", ObjProjectPresent);            
    // }, [sMode, arrProjectPresent]);
    //#endregion

    return (
        <ContentWrapper style={{ border: '0px solid #f1f1f1 !important', borderRadius: '10px', paddingBottom: '1%', padding: '2%',}}>
            {sMode === "403" ?
                <Grid item xs={12} md={12} container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <TextBoxItem
                            id={"sProjectName_" + sNameFrom}
                            name={"sProjectName_" + sNameFrom}
                            type={"text"}
                            label={"ชื่อโครงการ"}
                            required={false}
                            maxLength={250}
                            disabled={true}
                            defaultValue={ObjProjectPresent?.sProjectName ?? null}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextBoxItem
                            id={"sEventName_" + sNameFrom}
                            name={"sEventName_" + sNameFrom}
                            type={"text"}
                            label={"ชื่องาน"}
                            required={isPresent}
                            maxLength={250}
                            disabled={!isPresent}
                            onChange={(e)=> {
                                if (ObjProjectPresent !== null && e !== null) ObjProjectPresent.sEventName = e.target.value;
                            }}
                            defaultValue={ObjProjectPresent?.sEventName ?? null}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={5.7}>
                                <DatePickerItem
                                    id={"dPresentStart_" + sNameFrom}
                                    name={"dPresentStart_" + sNameFrom}
                                    label={ObjProjectPresent?.isNotDatePresentEnd === false ? "วันที่นำเสนอ เริ่มต้น" : "วันที่ตีพิมพ์"}
                                    fullWidth={true}
                                    required={isPresent}
                                    view={["year", "month"]}
                                    format={"MMMM YYYY"}
                                    disabled={!isPresent}
                                    minDate={dProjectStart}
                                    maxDate={formPresent.watch("dPresentEnd_" + sNameFrom)}
                                    // defaultCalendarMonth={dProjectStart ? moment(dProjectStart).startOf('year').year(dProjectStart.getFullYear()) : null}
                                    onChange={(e)=> {
                                        if (ObjProjectPresent != null && e != null) 
                                        {
                                            let dPresentStart = moment(e);
                                            // ObjProjectPresent.dPresentStart = dProjectStart;
                                            // ObjProjectPresent.nDatePresentStart = dProjectStart ? dProjectStart.valueOf() : null;
                                            let nDatePresentStart = dPresentStart.isValid ? ConvertDateToUnixOrNull(dPresentStart.startOf('month')) : null; 
                                            ObjProjectPresent.dPresentStart = dPresentStart;
                                            ObjProjectPresent.nDatePresentStart = nDatePresentStart;
                                        }
                                    }}
                                    defaultValue={ObjProjectPresent?.nDatePresentStart}
                                    // defaultValue={moment(ObjProjectPresent?.nDatePresentStart)}
                                    IsDisablePortal={true}
                                />
                            </Grid>
                            {ObjProjectPresent?.isNotDatePresentEnd === false &&
                                <>
                                    <Grid item display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                        -
                                    </Grid>
                                    <Grid item xs={5.7}>
                                        <DatePickerItem
                                            id={"dPresentEnd_" + sNameFrom}
                                            name={"dPresentEnd_" + sNameFrom}
                                            label={"สิ้นสุด"}
                                            fullWidth={true}
                                            required={isPresent}
                                            view={["year", "month"]}
                                            format={"MMMM YYYY"}
                                            disabled={!isPresent}
                                            minDate={formPresent.watch("dPresentStart_" + sNameFrom) || dProjectStart}
                                            // defaultCalendarMonth={dProjectStart ? moment(dProjectStart).startOf('year').year(dProjectStart.getFullYear()) : null}
                                            onChange={(e)=> {
                                                if (ObjProjectPresent != null && e != null) 
                                                {
                                                    let dPresentEnd = moment(e);
                                                    // ObjProjectPresent.dPresentEnd = dPresentEnd;
                                                    // ObjProjectPresent.nDatePresentEnd = dPresentEnd ? dPresentEnd.valueOf() : null;
                                                    let nDatePresentEnd = dPresentEnd.isValid ? ConvertDateToUnixOrNull(dPresentEnd.endOf('month')) : null;    
                                                    ObjProjectPresent.dPresentEnd = dPresentEnd;                                                    
                                                    ObjProjectPresent.nDatePresentEnd = nDatePresentEnd;
                                                }
                                            }}
                                            defaultValue={ObjProjectPresent?.nDatePresentEnd}
                                            IsDisablePortal={true}
                                        />
                                    </Grid>
                                </>
                            }
                        </Grid>
                    </Grid>
                    {ObjProjectPresent?.isNotDatePresentEnd === false ?
                        <Grid item xs={12} md={12}>
                            <TextAreaItem
                                id={"sDetail_" + sNameFrom}
                                name={"sDetail_" + sNameFrom}
                                label={"หัวข้อที่นำเสนอ"}                               
                                required={false}
                                maxLength={500}
                                row={3}
                                disabled={!isPresent}
                                onChange={(e)=> {
                                    if (ObjProjectPresent != null && e != null) ObjProjectPresent.sDetail = e.target.value;
                                }}
                                defaultValue={ObjProjectPresent?.sDetail ?? null}
                            />
                        </Grid>
                        :
                        <Grid item xs={12} md={12} container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextBoxItem
                                    id={"sJournalName_" + sNameFrom}
                                    name={"sJournalName_" + sNameFrom}
                                    type={"text"}
                                    label={"ชื่อวารสาร"}
                                    required={isPresent}
                                    maxLength={250}
                                    disabled={!isPresent}
                                    onChange={(e)=> {
                                        if (ObjProjectPresent != null && e !== null) ObjProjectPresent.sJournalName = e.target.value;
                                    }}
                                    defaultValue={ObjProjectPresent?.sJournalName ?? null}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextBoxItem
                                    id={"sArticleTitle_" + sNameFrom}
                                    name={"sArticleTitle_" + sNameFrom}
                                    type={"text"}
                                    label={"ชื่อบทความ"}
                                    required={isPresent}
                                    maxLength={250}
                                    disabled={!isPresent}
                                    onChange={(e)=> {
                                        if (ObjProjectPresent != null && e !== null) ObjProjectPresent.sArticleTitle = e.target.value;
                                    }}
                                    defaultValue={ObjProjectPresent?.sArticleTitle ?? null}
                                />
                            </Grid>
                        </Grid>
                    }
                    <Grid item xs={12} md={6}>
                        <TextBoxItem
                            id={"sPresentBy_" + sNameFrom}
                            name={"sPresentBy_" + sNameFrom}
                            type={"text"}
                            label={ObjProjectPresent?.isNotDatePresentEnd === false ? "ชื่อผู้นำเสนอหลัก" : "ชื่อผู้ตีพิมพ์ผลงานหลัก"}
                            required={isPresent}
                            maxLength={150}
                            disabled={!isPresent}
                            onChange={(e)=> {
                                if (ObjProjectPresent != null && e !== null) ObjProjectPresent.sPresentBy = e.target.value;
                            }}
                            defaultValue={ObjProjectPresent?.sPresentBy ?? null}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                        <UploadFileItem
                            required={isPresent}
                            modeDisplay={"list"}
                            id={"oFilePresent_" + sNameFrom}
                            name={"oFilePresent_" + sNameFrom}
                            label={"แนบเอกสาร"}
                            arrFile={ObjProjectPresent?.lstFilePresent ?? []}
                            setarrFile={(e) =>  {
                                if (ObjProjectPresent != null) ObjProjectPresent.lstFilePresent = (e || []);
                            }}
                            Extension={["pdf", "jpeg"]}
                            IsFolder={false}
                            onClearFile={onClearFile}
                            sFolderTemp="Project"
                            IsMultiple={true}
                            nLimitFile={30}
                            sLimitFile="MB"
                            sPositionText="right"
                            IsCrop={true}
                            cropShape={"retangle"}
                            cropRatio={16 / 9}
                            cropResize={true}
                            cropMovable={true}
                            disabled={!isPresent}
                        />
                    </Grid>
                </Grid>
                : 
                (sMode === "404" ?
                    <Grid id={"myDivPresent"} item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                        <FormProvider {...formPresent}>                    
                            <Grid item xs={12} md={12} container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <TextBoxItem
                                        id={"sEventName_S4_" + sNameFrom}
                                        name={"sEventName_S4_" + sNameFrom}
                                        type={"text"}
                                        label={"ชื่องาน"}
                                        required={isPresent}
                                        maxLength={250}
                                        disabled={!isPresent}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={5.7}>
                                            <DatePickerItem
                                                id={"dPresentStart_S4_" + sNameFrom}
                                                name={"dPresentStart_S4_" + sNameFrom}
                                                label={ObjProjectPresent?.isNotDatePresentEnd === false ? "วันที่นำเสนอ เริ่มต้น" : "วันที่ตีพิมพ์"}
                                                fullWidth={true}
                                                required={isPresent}
                                                view={["year", "month"]}
                                                format={"MMMM YYYY"}
                                                disabled={!isPresent}
                                                minDate={dProjectStart}
                                                maxDate={formPresent.watch("dPresentEnd_S4_" + sNameFrom)}    
                                                IsDisablePortal={true}                                   
                                            />
                                        </Grid>
                                        {ObjProjectPresent?.isNotDatePresentEnd === false &&
                                            <>
                                                <Grid item display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                                    -
                                                </Grid>
                                                <Grid item xs={5.7}>
                                                    <DatePickerItem
                                                        id={"dPresentEnd_S4_" + sNameFrom}
                                                        name={"dPresentEnd_S4_" + sNameFrom}
                                                        label={"สิ้นสุด"}
                                                        fullWidth={true}
                                                        required={isPresent}
                                                        view={["year", "month"]}
                                                        format={"MMMM YYYY"}
                                                        disabled={!isPresent}
                                                        minDate={formPresent.watch("dPresentStart_S4_" + sNameFrom) || dProjectStart}             
                                                        IsDisablePortal={true}                                        
                                                    />
                                                </Grid>
                                            </>
                                        }
                                    </Grid>
                                </Grid>
                                {ObjProjectPresent?.isNotDatePresentEnd === false ?
                                    <Grid item xs={12} md={12}>
                                        <TextAreaItem
                                            id={"sDetail_S4_" + sNameFrom}
                                            name={"sDetail_S4_" + sNameFrom}
                                            label={"หัวข้อที่นำเสนอ"}                               
                                            required={false}
                                            maxLength={500}
                                            row={3}
                                            disabled={!isPresent}
                                        />
                                    </Grid>
                                    :
                                    <Grid item xs={12} md={12} container spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <TextBoxItem
                                                id={"sJournalName_S4_" + sNameFrom}
                                                name={"sJournalName_S4_" + sNameFrom}
                                                type={"text"}
                                                label={"ชื่อวารสาร"}
                                                required={isPresent}
                                                maxLength={250}
                                                disabled={!isPresent}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextBoxItem
                                                id={"sArticleTitle_S4_" + sNameFrom}
                                                name={"sArticleTitle_S4_" + sNameFrom}
                                                type={"text"}
                                                label={"ชื่อบทความ"}
                                                required={isPresent}
                                                maxLength={250}
                                                disabled={!isPresent}
                                            />
                                        </Grid>
                                    </Grid>
                                }
                                <Grid item xs={12} md={6}>
                                    <TextBoxItem
                                        id={"sPresentBy_S4_" + sNameFrom}
                                        name={"sPresentBy_S4_" + sNameFrom}
                                        type={"text"}
                                        label={ObjProjectPresent?.isNotDatePresentEnd === false ? "ชื่อผู้นำเสนอหลัก" : "ชื่อผู้ตีพิมพ์ผลงานหลัก"}
                                        required={isPresent}
                                        maxLength={150}
                                        disabled={!isPresent}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                    <UploadFileItem
                                        required={isPresent}
                                        modeDisplay={"list"}
                                        id={"oFilePresent_S4_" + sNameFrom}
                                        name={"oFilePresent_S4_" + sNameFrom}
                                        label={sEmailFile === null ? "แนบเอกสารสื่อเผยแพร่และประชาสัมพันธ์" : "แนบเอกสารสื่อเผยแพร่และประชาสัมพันธ์ (กรณีเป็นสื่อวิดีโอให้แนบรูปภาพหน้าปกวิดีโอ และส่งลิงก์วิดิโอหรือไฟล์วิดีโอไปยังอีเมล " + sEmailFile + ")"}
                                        arrFile={arrFilePresent}
                                        setarrFile={setarrFilePresent}
                                        Extension={["pdf", "jpeg"]}
                                        IsFolder={false}
                                        onClearFile={onClearFile}
                                        sFolderTemp="Project"
                                        IsMultiple={true}
                                        nLimitFile={30}
                                        sLimitFile="MB"
                                        sPositionText="right"
                                        IsCrop={true}
                                        cropShape={"retangle"}
                                        cropRatio={16 / 9}
                                        cropResize={true}
                                        cropMovable={true}
                                        disabled={!isPresent}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                {(nPresentIDEdit === 0 && isPresent) ?
                                    <BtnAdd id={"btnAdd_Table_Present"} IsDisabled={!isPresent} txt={"เพิ่มสื่อ"} onClick={formPresent.handleSubmit((e) => onAddPresent(),(err) => console.log("err", err))} />
                                    :
                                    <>
                                        {isPresent &&
                                            <Grid item>
                                                <BtnSave id={"btnSave_Table_Present"} IsDisabled={!isPresent} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={formPresent.handleSubmit((e) => onAddPresent(),(err) => console.log("err", err))} />
                                            </Grid>
                                        }
                                        {nPresentIDEdit !== 0 &&
                                            <Grid item>
                                                <BtnCancel id={"btnCancel_Table_Present"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={(e) => { setnPresentIDEdit(0); setObjPresentIDEdit(null); onClearField(); }} />
                                            </Grid>
                                        }         
                                    </>
                                }
                            </Grid>
                            <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                                <DataGrid
                                    sTableID={"TB_ProjectPresent_" + sNameFrom}
                                    columns={ObjProjectPresent?.isNotDatePresentEnd === false ? dataColumn : dataColumnPresent}
                                    rows={DataRowPresent}
                                    isShowColomnTool={false}
                                    isHiddenToolHead={true}
                                    isShowCheckBox={false}
                                    isHiddenPagination={false}
                                />
                            </Grid>
                        </FormProvider>
                    </Grid>
                    :
                    <></>
                )
            }

        </ContentWrapper>
    )
}